
import { defineComponent } from "vue";
import Button from "../inputs/Button.vue";

export default defineComponent({
  components: {
    Button,
  },
  methods: {
    backstage() {
      window.open("https://scrapbox.io/MEGAMOJI/%F0%9F%93%8C_%E3%81%93%E3%82%8C%E3%81%AF%E3%81%AA%E3%81%AB%EF%BC%9F");
    },
    donation() {
      window.open("https://github.com/zk-phi/MEGAMOJI?tab=License-1-ov-file#readme");
    },
    share() {
      window.open("http://twitter.com/share?url=https://zk-phi.github.io/MEGAMOJI&text=カスタム絵文字メーカー%20MEGAMOJI&hashtags=メガ文字");
    },
  },
});
